<template>
    <button type="button" class="close" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</template>

<script>
    export default {
        name: "CloseButton"
    }
</script>

<style scoped>
    .close {
        outline: none;
        position: fixed;
        right: 3%;
        top: 6.5%;
        color: black;
        opacity: 1;
        text-shadow: 0 0 8px blue;
        z-index: 9999;
    }
    .close:hover {
        color: white;
        text-shadow: 0 0 8px yellow;
    }
</style>